import { render } from "./PropertyGrid.vue?vue&type=template&id=047152d0"
import script from "./PropertyGrid.vue?vue&type=script&lang=js"
export * from "./PropertyGrid.vue?vue&type=script&lang=js"

import "./PropertyGrid.vue?vue&type=style&index=0&id=047152d0&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__